module.exports = __webpack_public_path__ + "img/pig.1b332fc1.svg";